import React, { Component } from 'react';
import LedgerController from './ledger.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Card, Layout, Title } from '../common';
import LedgerTable from './elements/LedgerTable';
import LedgerTableActions from './elements/LedgerTableActions';

class Ledger extends Inherit(LedgerController, Component) {
    state = { user: {}, loading: true, ledger: [], rows: [] };

    render() {
        const { user, loading, ledger, rows } = this.state;
        return (
            <Layout user={user} fi={user?.fi?.name}>
                <Title title="Ledger" />
                <LedgerTableActions setRows={this.setRows.bind(this)} ledger={ledger} rows={rows} />
                <Card>
                    <LedgerTable rows={rows} loading={loading} />
                </Card>
            </Layout>
        );
    }
}

export default withHooks(Ledger);
